import { fromJS, Set, Map } from 'immutable';

import {
    ADD_REPORTS_FILTER,
    REMOVE_REPORTS_FILTER,
    CLEAR_REPORTS_FILTERS,
    GET_REPORTS_START,
    GET_REPORTS_SUCCESS,
    GET_REPORTS_ERROR,
} from './reports.action';

const initialState = fromJS({
    filters: new Set(),
    reports: {},
    reportsInit: false,
    reportsLoading: false,
});

export const reports = (state = initialState, action) => {
    switch (action.type) {
        case ADD_REPORTS_FILTER:
            return state.withMutations(ctx => {
                const { filter } = action.payload;
                const filters = ctx.get('filters');
                const thisFilter = Array.from(filters).filter(f => f.type === filter.type && f.value === filter.value);
                if (thisFilter.length > 0) {
                    ctx.set('filters', filters.delete(thisFilter[0]));
                } else {
                    ctx.set('filters', filters.add(filter));
                }
            });
        case REMOVE_REPORTS_FILTER:
            return state.withMutations(ctx => {
                const { filter } = action.payload;
                const filters = ctx.get('filters');
                const thisFilter = Array.from(filters).filter(
                    f => f.type === filter.type && (filter.single || f.value === filter.value)
                );
                if (thisFilter.length > 0) {
                    let newFilters = filters.delete(thisFilter[0]);
                    if (filter.single) {
                        newFilters = newFilters.add(filter);
                    }
                    ctx.set('filters', newFilters);
                }
            });
        case CLEAR_REPORTS_FILTERS:
            return state.withMutations(ctx => {
                const { type } = action.payload;
                const filters = ctx.get('filters');
                if (type === '') {
                    ctx.set('filters', new Set());
                } else {
                    const newFilters = Array.from(filters).filter(f => f.type !== type);
                    ctx.set('filters', new Set(newFilters));
                }
            });
        case GET_REPORTS_START:
            return state.withMutations(ctx => {
                ctx.set('reportsInit', true);
                ctx.set('reportsLoading', true);
                ctx.set('reports', new Map({}));
            });
        case GET_REPORTS_SUCCESS:
            return state.withMutations(ctx => {
                ctx.set('reportsLoading', false);
                ctx.set('reports', new Map(action.payload.data));
            });
        case GET_REPORTS_ERROR:
            return state.withMutations(ctx => {
                ctx.set('reportsLoading', true);
                ctx.set('reports', new Map({}));
            });
        default:
            return state;
    }
};
